module.exports = __webpack_public_path__ + "img/Changsheng_Xu@2x.15ee06ac.png";